<template>
  <div v-if="showPopup" class="popup-overlay">
      <div class="popup card">
          <div class="flex items-center justify-between">
            <p class="p-2 font-opensans font-semibold text-base" v-if="formattedRemainingTime === 'Session Expired'">Time Out!!</p>
            <p class="font-opensans font-semibold text-sm" v-else>Your Session is Expiring Soon!!</p>
            <!-- <button class="float-right text-3xl m-2" @click="onCrossBtn()" :hidden="formattedRemainingTime === 'Session Expired'" > -->
                <!-- <img  src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer"  /> -->
            <!-- </button> -->
          </div>
        <div class="border-b border-solid border-lightgrey mt-2"></div>
        <div class="flex pt-3 gap-5">
          <div class="mainSession">
            <img src="@/assets/sessionTimerGradient.svg" class="sessionTimer"/>
            <span class="font-opensans">{{ formattedRemainingTime }}</span>
          </div>
          <div class="contentOfSession flex flex-col justify-center">
            <div class="sessionText open-sans">
              <p>
                Click
              <span class="font-semibold text-black textSize font-opensans px-1">"Extend Session"</span>
              to keep working.
              </p>
              <p>Click<span class="font-semibold text-black textSize font-opensans px-1">"Logout"</span>
              to end your session now.</p>
            </div>
            <div class="flex buttonStyling">
              <div class="flex items-end">
                <button
                  type="button"
                  class="extendSessionButton filterButton widthForLogout"
                  @click="logout"
                >
                  Logout Now
                </button>
              </div>
              <div class="flex items-end ">
                <button
                  type="button"
                  class="filterButton buttonposition"
                  v-if="formattedRemainingTime !== 'Session Expired'"
                  @click="extendSession"
                >
                  Extend Session
                </button>
              </div>
            </div>
          </div>
          <div>
      </div>
        </div>
      </div>
  </div>
</template>
 
<style scoped>
.card {
  width:480px;
  height:250px;
  background-color: #ffffff;
  padding-top: 20px;
  padding-left:20px;
  padding-right:20px;
  border-radius: 8px;
}
.buttonStyling{
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: nowrap;
  align-items: flex-end;
  padding-top: 24px;
}
.widthForLogout{
  width:124px;
  padding-left: 0px;
  padding-right: 0px;
}
.contentOfSession{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px; /* Controls vertical spacing between child elements */
}
.buttonposition{
  background-color:var(--color-primary);
  border: 1px solid var(--color-primary);
  cursor: pointer;
  color:white;
  width: 124px;
  padding-left: 0px;
  padding-right: 0px;
}
.buttonposition:hover{
    box-shadow: 1px 1px 4px 4px rgba(25, 118, 210, 0.2);
  
}
.sessionText{
  padding-top: 24px;
  font-size: 12px;
  font-family: open-sans !important;
}
.mainSession {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.mainSession span {
  position: absolute;
  top:56%;
  left: 50%;
  transform: translate(-50%, -50%);
  color:black;
  font-size: 22px;
  font-family: 'Open Sans';
  font-weight: 600;
}
/* .container{
  background-color: #b37171;
  border-radius: 50%;
}
.progress-container{
  align-items: center;
  background-color: #119BB9;
  justify-items: center;
} */
.timeRemaining{
  color:#1976d2 ;
}
 .textSize{
    font-size:12px;
    margin-top: 18px;
    line-height: 20px;
  }
img,video{
  max-width:none;
  width:140px;
 }
 
.progress-container {
  text-align: center; 
  font-size: 16px; 
}
 
.extendSessionButton{
  background-color: #ffffff;
  border: 1px solid #1976d2;
  color: #1976d2;
  cursor: pointer;
}
.extendSessionButton:hover {
    background-color: #1976d2;
    border: 1px solid #1976d2;
    color: #ffffff;
}
.extendSessionButton:disabled:hover{
  background-color: #ffffff; 
  border: 1px solid #1976d2;
  color: #1976d2;
  opacity:0.5;
}
</style>
 
<script lang="ts">
import { emitter ,toast} from '@/main';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
 
export default defineComponent({
  data():any {
    return {
      sessionTimeout: 10, // 30 minutes default
      // warningTime: 5,    // 1 minute default
      warningTime : `${process.env.VUE_APP_WARNING_TIME}`,
      showPopup: false,
      timer: null,
      time:null,
      warningTimer: null,
      isSessionVisible:true,
      formattedRemainingTime:'',
      isVisible:false,
    };
  },
  mounted() {
     emitter.off('showPopup');
      emitter.on('showPopup',(data:any)=>{
          this.showPopup = data;
          this.isVisible = data;
          emitter.emit('isvisible',this.isVisible)
          
      })
    this.startSessionTimer();
    this.getAllTenants()
   
    emitter.off('updateFormattedRemainingTime');
    emitter.on('updateFormattedRemainingTime',(data:any)=>{
      if(data=='Session Expired'){
          this.showPopup=false;
          this.isVisible = false;
          emitter.emit('isvisible',this.isVisible);
          this.logout();
        }
      this.formattedRemainingTime = data;
     
    })
 
  },
    computed: {
    ...mapGetters({ userInfo: 'userInfo' }),
  },
  methods: {
 
    async getAllTenants() {
 
      this.$http.get(`${process.env.VUE_APP_AUTH_API_URL}/tenants/getAll`).then((res: any) => {
        this.allTenants = res.data;
        this.allTenants.filter((tenant:any) => {
        let userDomain = this.userInfo.email.substring(this.userInfo.email.lastIndexOf("@") + 1);
              let  userOrgDetails = userDomain.split('.')[0];
 
        if( userOrgDetails.toLowerCase()==tenant.tenantName.toLowerCase()){
          this.sessionTimeout= tenant.sessionTime/60
        }
         
        });
      });
    },
  startSessionTimer() {
        // Clear previous timers to avoid multiple active timers
        if (this.timer) clearTimeout(this.timer);
        if (this.warningTimer) clearTimeout(this.warningTimer);
     
        // Convert minutes to seconds
        const sessionTimeoutSec = this.sessionTimeout * 60; // Total session timeout in seconds
        const warningTimeSec = this.warningTime * 60; // Warning time in seconds
        const timeUntilWarning = sessionTimeoutSec - warningTimeSec; // Time until warning in seconds
 
        console.log('timeuntill',timeUntilWarning,this.formattedRemainingTime);
 
            // Convert minutes to seconds
            const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
            const expiresTime = this.userInfo.expires; // Expiration time in seconds
            const remainingTime = expiresTime - currentTime;
       
     
        // Ensure warning time is positive and that there's time left for the warning
        if (timeUntilWarning > 0) {
         
          // Set warning timer (convert time to milliseconds for setTimeout)
            // this.warningTimer = setTimeout(() => {
            //   console.log("Showing session timeout warning popup!");
            //   this.showPopup = true;
            //   this.isVisible = true;
             
            //   // emitter.emit('isvisible',this.isVisible);
            //     // Use nextTick to ensure DOM is updated after showPopup changes
            //   this.$nextTick(() => {
            //     emitter.emit('isvisible', this.isVisible);
            //     emitter.emit('showpopupvisible',this.showPopup);
            //   });
            // }, timeUntilWarning * 1000); // Convert to milliseconds
          //refresh logic
          if( sessionTimeoutSec > warningTimeSec && remainingTime && remainingTime <= warningTimeSec) {
            this.showPopup = true;
            this.sessionPopupVisible = true;
            emitter.emit('sessionPopupVisible',this.sessionPopupVisible);
            emitter.emit('')
          }
        }
         else {
        console.log("Warning time already passed, showing popup immediately.");
        this.showPopup = true;
      }
       
     
        // Set session expiration timer (this timer handles the actual session expiration)
        this.timer = setTimeout(() => {
          // this.showPopup=true;
        }, sessionTimeoutSec * 1000); // Convert to milliseconds for setTimeout
      }
,
    extendSession() {
 
        this.$http.get(`${process.env.VUE_APP_AUTH_API_URL}/authentication/extend-session`).then((res: any) => {
          if (this.timer) clearTimeout(this.timer);
          this.startSessionTimer();
          this.showPopup = false;
          this.isVisible = false;
          emitter.emit('isvisible',this.isVisible);
          emitter.emit('session-extended', res.data.newExpiryTime);
        })
        .catch((error:any) => console.error('Error extending session:', error));
    },
    // onCrossBtn(){
    //   this.isSessionVisible = false;
    //   this.isVisible = false;
    //   emitter.emit('isvisible',this.isVisible)
    // },
    async logout() {
      var payload = {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
        }
      };
      await this.$http
        .post(`${process.env.VUE_APP_AUTH_API_URL}/logout`, payload)
        .then((response: any) => {
          if (response.status == 200) {
            toast.success(`Logout Successfully`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: 'button',
              icon: true
            });
          }
        })
        .catch((error: any) => {
          toast.error(`Save failed with ${error}`, {
            timeout: 1000,
            closeOnClick: true,
            closeButton: 'button',
            icon: true
          });
        });
 
      localStorage.removeItem('AUTH_ID');
      window.location.replace(`${process.env.VUE_APP_AUTH_WEBAPP_URL}/logout?returnTo=${process.env.VUE_APP_TRAINING_WEBAPP_URL}`);
    }
  },
  beforeUnmount() {
    if (this.timer) clearTimeout(this.timer);
    emitter.off('updateFormattedRemainingTime');
  },
 
});
</script>